<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            modalWidth="80%"
            ref="master"
            :beforeSend="master.beforeSend"
            :useMultipart="true"
            :parentData="parentData"
            @action="masterAction"
  >
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <a-form-item :label="$t('Fecha documentación')" v-bind="fiOptions">
            <a-date-picker style="width: 100%"
                           valueFormat="Y-MM-DD HH:mm:ss"
                           v-decorator="['date_document', { rules: [{ required: false, message: 'Valor requerido' }] }]"></a-date-picker>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Nombre')">
            <a-input
              v-decorator="['nombre', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Observación')">
            <a-textarea auto-size
                        v-decorator="['observation', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
          </a-form-item>
        </a-col>
        <a-col v-bind="colOptions">
          <a-form-item v-bind="fiOptions" :label="$t('Subir archivo')">
            <a-upload
              name="profile_file"
              :before-upload="beforeUpload"
              :fileList="master.uploads.profileFile"
              :remove="() => { master.uploads.profileFile = [] }">
              <a-button style="width: 100%">Seleccionar archivo</a-button>
            </a-upload>
          </a-form-item>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import JsUtils from '@/util/JsUtils'

  export default {
    data () {
      return {
        loadingBtns: {},
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          uploads: {
            profileFile: []
          },
          beforeSend: (data) => {
            if (this.master.uploads.profileFile.length > 0) {
              data.profileFile = this.master.uploads.profileFile[0]
            }
            return data
          },
          endpoint: 'documentcase',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                },
                {
                  name: 'download',
                  text: 'Descargar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color: red'},
                  fnVisible: (record) => {
                    return record.file_name
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id_document_cases] === record.id_document_cases
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'id_document_cases'
            },
            columns: [
              {title: 'ID Documentación', dataIndex: 'id_document_cases', sorter: true},
              {title: 'Fecha documentación', dataIndex: 'fecha_documento', sorter: true},
              {title: 'Nombre', dataIndex: 'nombre', sorter: true},
              {title: 'Observación', dataIndex: 'observation', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'date_document'},
            {name: 'nombre'},
            {name: 'observation'}
          ]
        }
      }
    },
    props: ['id_case'],
    computed: {
      parentData () {
        return {id_case: this.id_case}
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterAction (action) {
        if (action.action === 'masterCreate' || action.action === 'masterEdit') {
          this.master.uploads.profileFile = []
        }
        switch (action.action) {
          case 'download':
            this.downloadFile(action.record)
            break
        }
      },
      downloadFile (record) {
        this.loadingBtns[record.id_document_cases] = record.id_document_cases
        this.loadingBtns = Object.assign({}, this.loadingBtns)

        this.httpClient.getInstance().post('documentcase/download', {
          id_document_cases: record.id_document_cases
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }

          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.id_document_cases]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        })
      },
      beforeUpload (file) {
        if (this.validateFile(file)) {
          this.master.uploads.profileFile = [file]
        }
        return false
      },
      validateFile (file) {
        const array = ['application/pdf', 'image/jpeg', 'text/html', 'text/plain']
        const isJpgOrPng = file.type
        if (!array.includes(isJpgOrPng)) {
          this.$message.error('Solo se pemiten documentos pdf, jpeg o jpg, texto plano o html')
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/Documentos.vue